import styled from 'styled-components';

export default styled.input`
  display: block;
  width: 100%;
  border: ${props => props.name === 'time' 
    ? 'none' 
    : props.error ? '1px solid rgba(255, 98, 86, 1)' : '1px solid rgba(225, 227, 244, 1)'};
  background: ${props => props.readOnly ? 'rgba(0, 0, 0, 0.2)' : props => props.disabled ? 'rgb(229, 232, 241)' : 'transparent'};
  min-height: 4.5rem;
  height: fit-content;
  border-radius: 0.2rem;
  padding: 0 1rem;
  color:  ${props => props.error 
    ? 'rgba(255, 98, 86, 1)' 
    : props.disabled ? 'rgba(198, 202, 219, 1)' : 'rgba(39, 39, 39, 1)'};
  line-height: 1.5rem;
  font-size: 1.4rem;
  cursor: ${props =>  props.isEditable ? 'pointer' : props => props.disabled || props.readOnly ? 'default' : props.type === 'range' ? 'pointer' : 'text'};

  &:focus {
    border: ${props => props.noFocus && typeof props.noFocus === 'string' ? props.noFocus : props.noFocus || props.readOnly || props.disabled ? '0 solid rgba(225, 227, 244, 1)' : '1px solid rgba(111, 88, 255, 1)'};
    caret-color: ${props => props.noCaret ? 'transparent' : 'inherit'};
    ${props => props.thisStyles 
      ? `
        ${props.thisStyles}
        border-width: 2px;
      ` 
      : 'rgba(111, 88, 255, 1);'}
    ${ props => props.noFocus ? 'outline: none;' : ''}
  }

  &[type=range] {
  -webkit-appearance: none;
  margin: 0;
  border: none;
  width: 100%;
}
&[type=range]:focus {
  outline: none;
}
&[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  cursor: pointer;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  background: rgba(111, 88, 255, 1);
  border-radius: 2.5rem;
  border: 0px solid #000101;
}
&[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  border: 1px solid rgba(111, 88, 255, 1);
  height: 1.5rem;
  width: 1rem;
  border-radius: 0.7rem;
  background: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -0.5rem;
}
&[type=range]:focus::-webkit-slider-runnable-track {
  background: rgba(111, 88, 255, 1);
}
&[type=range]::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  background: rgba(111, 88, 255, 1);
  border-radius: 2.5rem;
  border: 0px solid #000101;
}
&[type=range]::-moz-range-thumb {
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  border: 1px solid rgba(111, 88, 255, 1);
  height: 1.5rem;
  width: 1rem;
  border-radius: 0.7rem;
  background: #fff;
  cursor: pointer;
}
&[type=range]::-ms-track {
  width: 100%;
  height: 0.5rem;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 1rem 0;
  color: transparent;
}
&[type=range]::-ms-fill-lower {
  background: rgba(111, 88, 255, 1);
  border: 0px solid #000101;
  border-radius: 5rem;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}
&[type=range]::-ms-fill-upper {
  background: rgba(111, 88, 255, 1);
  border: 0px solid #000101;
  border-radius: 5rem;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}
&[type=range]::-ms-thumb {
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  border: 1px solid rgba(111, 88, 255, 1);
  height: 1.5rem;
  width: 1rem;
  border-radius: 0.7rem;
  background: #fff;
  cursor: pointer;
}
&[type=range]:focus::-ms-fill-lower {
  background: rgba(111, 88, 255, 1);
}
&[type=range]:focus::-ms-fill-upper {
  background: rgba(111, 88, 255, 1);
}




  ${props => props.thisStyles}

  

  &::placeholder {
    ${props => props.placeholderStylesCss}
  }


`;
